import get from 'lodash/get';
import cjaAnalytics from 'yoda-core-components/lib/helpers/Analytics/CJAAnalytics';
import buildCJAPageViewPayload from 'yoda-core-components/lib/helpers/Analytics/CJAPageViewBuilder';
import TokenProvider from 'yoda-core-components/lib/helpers/TokenProvider/TokenProvider';

const legacyVersion = 'apollo 1 2017 redesign yoda account';

const legacyPages = [
    'sign in',
    'create account',
    'my account',
    'reset password',
    'sign out',
    'session timeout',
    'full access timeout',
];

const getPageFields = (pageName) => {
    const name = (pageName || '').toLowerCase();
    return {
        name,
        type: 'account',
        siteSection: 'account',
        category: { primary: 'account' },
        tech: {
            version: legacyPages.includes(name)
                ? legacyVersion
                : `apollo 1 ${new Date().getFullYear()} yoda account`,
        },
    };
};

const getUserOverrides = (state) => {
    const overrides = {};

    // PII fields — not exposed to adobeDataLayer
    // const profile = get(state, 'accountDetails.profile', {});
    // if (profile.firstName) overrides.firstName = profile.firstName;
    // if (profile.lastName) overrides.lastName = profile.lastName;
    // if (profile.emailAddress) overrides.email = profile.emailAddress;
    // if (profile.phoneNumber) overrides.phoneNumber = profile.phoneNumber;

    const defaultAddress = get(state, 'addressDetails.defaultAddress', {});
    // if (defaultAddress.addressLineOne) overrides.address = defaultAddress.addressLineOne;
    if (defaultAddress.state) overrides.state = defaultAddress.state;
    if (defaultAddress.zip) overrides.zip = defaultAddress.zip;

    const rewardsTier = TokenProvider.get('DP_REWARDS_TIER');
    if (rewardsTier) overrides.rewardsMemberType = rewardsTier;

    const rewardsStatus = TokenProvider.get('DP_REWARDS_STATUS');
    if (rewardsStatus) overrides.loyalityTier = rewardsStatus;

    return overrides;
};

const trackCJAPageView = (store, pageName) => {
    if (__SERVER__) return;

    try {
        const state = store.getState();
        const pageData = getPageFields(pageName);
        const userOverrides = getUserOverrides(state);
        const extraData = { interactionName: 'regular_pageview' };
        const payload = buildCJAPageViewPayload(pageData, userOverrides, extraData);
        payload.event = payload.event_name;
        cjaAnalytics.track('pageView', payload);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('[CJA Account]', error);
    }
};

// eslint-disable-next-line import/prefer-default-export
export { trackCJAPageView };
